import ApiError from "../../../api/common/apiError";
import {
    CPCAndTachoAnalysis,
    EyeSightAnalysis,
    LicenceCategoriesAnalysis,
    LicenceChangedAnalysis,
    LicenceStatusAnalysis,
    NewDriversAnalysis,
    NonAddressMatchAnalysis,
    PhotoCardsAnalysis,
    ProfessionalLicenceStatusAnalysis,
    ProfessionalNewDriversAnalysis,
    RiskCategoriesAnalysis,
} from "../../../components/AnalysisViews/DriverAnalysisViews";
import { type AnalysisComponentContentType } from "../../../components/ReusableComponents/AnalysisComponent/AnalysisComponent";
import {
    DriverAnalysisTabs,
    type CompanyDriverAnalysisResponse,
} from "../../../models/api/admin/companyDriverAnalysis";

export const driverAnalysisContent = (
    data?: CompanyDriverAnalysisResponse,
    error?: ApiError,
    isCompanySelected?: boolean
) => {
    const analysisContent: AnalysisComponentContentType<DriverAnalysisTabs>[] =
        [
            {
                title: DriverAnalysisTabs.RiskCategories,
                content: (
                    <>
                        {!error && (
                            <RiskCategoriesAnalysis
                                data={data?.riskCategories}
                                isCompanySelected={isCompanySelected}
                            />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["drivers", "professionalDrivers"],
            },
            {
                title: DriverAnalysisTabs.CpcAndTacho,
                content: (
                    <>
                        {!error && (
                            <CPCAndTachoAnalysis data={data?.cpcTacho} />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["professionalDrivers"],
            },
            {
                title: DriverAnalysisTabs.LicenceStatus,
                content: (
                    <>
                        {!error && (
                            <LicenceStatusAnalysis data={data?.licenceStatus} />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["drivers"],
            },
            {
                title: DriverAnalysisTabs.ProfessionalLicenceStatus,
                content: (
                    <>
                        {!error && (
                            <ProfessionalLicenceStatusAnalysis
                                data={data?.professionalLicenceStatus}
                            />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["professionalDrivers"],
            },
            {
                title: DriverAnalysisTabs.LicenceChanged,
                content: (
                    <>
                        {!error && (
                            <LicenceChangedAnalysis
                                data={data?.driverLicenceChanges}
                            />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["drivers", "professionalDrivers"],
            },
            {
                title: DriverAnalysisTabs.LicenceCategories,
                content: (
                    <>
                        {!error && (
                            <LicenceCategoriesAnalysis
                                data={data?.licenceCategories}
                            />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["drivers", "professionalDrivers"],
            },
            {
                title: DriverAnalysisTabs.PhotoCards,
                content: (
                    <>
                        {!error && (
                            <PhotoCardsAnalysis data={data?.photocards} />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["drivers", "professionalDrivers"],
            },
            {
                title: DriverAnalysisTabs.NewDrivers,
                content: (
                    <>
                        {!error && (
                            <NewDriversAnalysis data={data?.newDrivers} />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["drivers"],
            },
            {
                title: DriverAnalysisTabs.ProfessionalNewDrivers,
                content: (
                    <>
                        {!error && (
                            <ProfessionalNewDriversAnalysis
                                data={data?.professionalNewDrivers}
                            />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["professionalDrivers"],
            },
            {
                title: DriverAnalysisTabs.Eyesight,
                content: (
                    <>
                        {!error && <EyeSightAnalysis data={data?.eyesight} />}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["drivers", "professionalDrivers"],
            },
            {
                title: DriverAnalysisTabs.NonADDMatches,
                content: (
                    <>
                        {!error && (
                            <NonAddressMatchAnalysis
                                data={data?.nonAddressMatch}
                            />
                        )}
                        {error && <ErrorMessage />}
                    </>
                ),
                locations: ["drivers", "professionalDrivers"],
            },
        ];

    return analysisContent;
};

const ErrorMessage = () => {
    return (
        <div className="rounded border-2 border-S2D-error-40 bg-S2D-error-90 p-4 text-S2D-neutral-10">
            Error fetching driver analysis data
        </div>
    );
};
